import queryString from "query-string";

import { ECONTRACT_SPECIAL_CONDITION } from "constants/actionTypes";

import { serializeEContractSpecialCondition } from "lib/serializers/eContractSpecialConditions";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

interface UrlCreatorProps {
  id?: string;
  changesSince?: number;
  agreementId?: string;
  livestockSaleId?: number;
}

const urlCreator = ({
  id,
  changesSince,
  agreementId,
  livestockSaleId,
}: UrlCreatorProps = {}) => {
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction(`/v2/econtract-special-conditions/`, id),
    query: {
      changesSince,
      agreement__cbid: agreementId,
      livestock_sale_id: livestockSaleId,
    },
  });
};

export const EContractSpecialConditionAction = offlineActionCreator(
  ECONTRACT_SPECIAL_CONDITION,
  serializeEContractSpecialCondition,
  urlCreator,
  true,
);
